module.exports = __webpack_public_path__ + "img/icn_radio_checked.1e15cb97.svg";